(function () {
  function initSection(section) {
    if (!section || section.dataset.odditFeaturedProductsInit === 'true') return;
    var tabs = section.querySelectorAll('.oddit-section-featured-products__tab');
    var panels = section.querySelectorAll('.oddit-section-featured-products__panel');
    if (!tabs.length) return;

    function activateTab(targetTab) {
      var targetId = targetTab.getAttribute('aria-controls');

      for (var i = 0; i < tabs.length; i++) {
        var tab = tabs[i];
        var isActive = tab === targetTab;
        tab.classList.toggle('oddit-section-featured-products__tab--active', isActive);
        tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
        tab.setAttribute('tabindex', isActive ? '0' : '-1');
      }

      for (var j = 0; j < panels.length; j++) {
        var panel = panels[j];
        var isMatch = panel.id === targetId;
        panel.classList.toggle('oddit-section-featured-products__panel--active', isMatch);
      }
    }

    for (var k = 0; k < tabs.length; k++) {
      tabs[k].addEventListener('click', function (e) {
        e.preventDefault();
        activateTab(e.currentTarget);
      });

      tabs[k].addEventListener('keydown', function (e) {
        if (e.key !== 'ArrowLeft' && e.key !== 'ArrowRight') return;
        e.preventDefault();
        var currentIndex = -1;
        for (var idx = 0; idx < tabs.length; idx++) {
          if (tabs[idx] === e.currentTarget) {
            currentIndex = idx;
            break;
          }
        }
        if (currentIndex === -1) return;
        var nextIndex = e.key === 'ArrowRight'
          ? (currentIndex + 1) % tabs.length
          : (currentIndex - 1 + tabs.length) % tabs.length;
        tabs[nextIndex].focus();
        activateTab(tabs[nextIndex]);
      });
    }

    section.dataset.odditFeaturedProductsInit = 'true';
  }

  function initAll(root) {
    var scope = root || document;
    var sections = scope.querySelectorAll('.oddit-section-featured-products');
    for (var i = 0; i < sections.length; i++) {
      initSection(sections[i]);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (e) {
    if (!e.target) return;
    if (e.target.classList && e.target.classList.contains('oddit-section-featured-products')) {
      initSection(e.target);
    } else {
      initAll(e.target);
    }
  });
})();
